import axios from "../authApi";

type ConfirmLoginResponse = {
  loggedIn: boolean;
  priceId?: string;
  discountId?: string;
  is_new_user?: boolean;
  redirectTo?: string;
};

export const confirmLoginWithCode = async (
  email: string,
  verificationCode: string,
  favoriteClubs?: number[],
  favoriteCountries?: number[],
): Promise<ConfirmLoginResponse> => {
  const res = await axios.post("/auth/confirm-login", {
    email,
    verificationCode,
    ...(favoriteClubs?.length && { favoriteClubs }),
    ...(favoriteCountries?.length && { favoriteCountries }),
  });
  localStorage.setItem(
    "access_token",
    JSON.stringify(res.data["access_token"]),
  );
  return {
    loggedIn: !!res.data["access_token"],
    priceId: res.data["priceId"],
    discountId: res.data["discountId"],
    is_new_user: res.data["is_new_user"],
    redirectTo: res.data["redirectTo"],
  };
};
